













































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {$, ID, success} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {UploadConfig} from '@/config/upload.config'
import {FileFormat} from '@/enums/FileFormat'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import ModalShare from '@/components/modals/ModalShare.vue'
import ModalUpload from '@/components/modals/ModalUpload.vue'
import Carga from '@/model/resource/Carga'
import CargaDanfeRequest from '@/model/request/CargaDanfeRequest'
import * as Helper from '@/helpers'
import TipoFotoAtlas from '@/model/resource/TipoFotoAtlas'
import PhotoSection from '@/views/get/PhotoSection.vue'
import {cloneDeep} from 'lodash'
import moment from 'moment'

interface Changing {
  [name: string]: string,
}

interface FotosList {
  [name: string]: string[],
}

@Component({
  components: {PhotoSection, ModalShare, ModalUpload},
})
export default class DeliveryPhotoSection extends Vue {
  @Prop({type: [String, Number]}) id?: ID
  @Prop({type: [Object]}) carga!: Carga
  @Prop({type: String, default: null}) hash!: string | null

  AppConfig = AppConfig
  UploadConfig = UploadConfig
  FileFormat = FileFormat
  DeliveryStatus = DeliveryStatus
  Helper = Helper
  tipoFotoAtlas: TipoFotoAtlas[] = []
  TipoFotoAtlas = TipoFotoAtlas
  cargaCopy = new Carga()

  changing = ''

  async created() {
    // this.$await.init('getTipoFotoAtlas')
    // const resp = await TipoFotoAtlas.getListTipoFotoAtlas()
    // this.tipoFotoAtlas = resp.data
    // this.$await.done('getTipoFotoAtlas')
    this.cargaCopy = cloneDeep(this.carga)
  }

  get guestMode() {
    return !!(this.id && this.hash)
  }

  emitRefresh() {
    this.$emit('refreshAudit')
  }

  get status() {
    if (this.carga.statusCarga) {
      return this.carga.statusCarga.$id as DeliveryStatus
    }
    return null
  }

  get isDeliveryPending() {
    return [DeliveryStatus.PENDING].includes(this.status as DeliveryStatus)
  }

  get isDeliveryStarted() {
    return [DeliveryStatus.STARTED].includes(this.status as DeliveryStatus)
  }

  get uploadTitle() {
    return this.$t(`view.get.deliveryGet.upload${this.capitalizeFirstLetter(this.changing)}Image`) as string
  }

  get urlsResource() {
    const cargaAux: FotosList = {...this.carga} as unknown as FotosList

    const fotos: Changing = {
      initial: 'fotosInicio',
      comprovante: 'fotosComprovantes',
      ocorrencia: 'fotosOcorrencia',
      epis: 'fotosEpiFerramentas',
      lacres: 'fotosLacresECaminhaoDeslonado',
      espelho: 'fotosEspelhos',
      guias: 'fotosGuias',
      pedras: 'fotosPedrasDoContrapeso',
      processo: 'fotosProcesso',
    }

    return cargaAux[fotos[this.changing] || 'fotosVolumesArmazenados']
  }

  set urlsResource(val: string[]) {
    this.persistUpload(val)
  }

  changeReplicarCTE() {
    this.carga.replicarCTE = !this.carga.replicarCTE
  }

  async persistUpload(val: string[]) {
    const fotos: Changing = {
      initial: 'fotosInicio',
      comprovante: 'fotosComprovantes',
      ocorrencia: 'fotosOcorrencia',
      epis: 'fotosEpiFerramentas',
      lacres: 'fotosLacresECaminhaoDeslonado',
      espelho: 'fotosEspelhos',
      guias: 'fotosGuias',
      pedras: 'fotosPedrasDoContrapeso',
      processo: 'fotosProcesso',
    }
    const fotosValue = {
      [fotos[this.changing] || 'fotosVolumesArmazenados']: val,
    }

    try {
      const request = new CargaDanfeRequest() as CargaDanfeRequest
      request.carga = {...this.carga, ...fotosValue} as Carga
      // @ts-ignore
      this.carga[fotos[this.changing]] = val
      if (this.changing === 'processo') {
        await this.carga.persistFotosProcesso(request)
      } else {
        await this.carga.persistFotos(request)
      }
      this.cargaCopy = cloneDeep(this.carga)
      success('system.success.persist')
    } catch (e) {
        await this.refresh()
    }
  }

  changePhoto(item: string) {
    this.changing = item
    this.carga = cloneDeep(this.cargaCopy)
    this.$modal.open('upload')
  }

  async refresh(spinner?: string) {
    if (this.guestMode) {
      const hash = this.hash ? encodeURIComponent(this.hash) : null
      return this.carga.findByQuery({id: this.id, hash})
    }

    if (this.id) await this.carga.find(this.id, spinner)

    if (this.carga.cargaConcreto) {
      this.carga.cargaConcreto.usina = this.carga.sigla
    }

    $.await.done('findCarga')
  }

  capitalizeFirstLetter(value: string) {
    return value.charAt(0).toUpperCase() + value.slice(1)
  }

  // isRequired(tipoFoto: number) {
  //   return this.tipoFotoAtlas.some((it) => it.idTipoFotoAtlasPk === tipoFoto && it.obrigatorio)
  // }

  get showFotosOcorrencia() {
    return this.carga.tipoOcorrencia && this.carga.tipoOcorrencia.idOcorrenciaPk
  }

  get cargaImageName() {
    if (Helper.isInterlog()) return ''

    const nroFiscal = this.carga.nroNotaFiscal || '00000000'
    const serie = this.carga.serialNumber || '000'
    const cnpjEmitente = this.carga.embarcador.cnpj || '00000000000000'

    const idOcorrenciaExterna = this.carga.tipoOcorrencia && this.carga.tipoOcorrencia.idOcorrenciaExterna
    const idOcorrencia = this.carga.tipoOcorrencia && this.carga.tipoOcorrencia.idOcorrenciaPk
    const codOcorrencia =  idOcorrenciaExterna || idOcorrencia || '00'

    const dataOcorrencia = moment(this.carga.dataFinalizacao).format('DDMMYYYY') || 'DDMMYYYY'
    const horaOcorrencia = moment(this.carga.dataFinalizacao).format('HHmm') || 'HHMM'

    return `${nroFiscal}_${serie}_${cnpjEmitente}_${codOcorrencia}_` +
        `${dataOcorrencia}_${horaOcorrencia}_@filename`
  }
}
